<core-breadcrumb>
  <core-breadcrumb-item
    *ngFor="let breadcrumb of breadcrumbs"
    [text]="breadcrumb.label"
    [url]="breadcrumb.url"
    (click)="nav(breadcrumb.url, $event)"
  ></core-breadcrumb-item>
</core-breadcrumb>
